import styled from 'styled-components'

import { colors } from '@/styles/colors'

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 160px;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;

    &:has(.footer) {
        tr:last-child {
            td {
                border-bottom: 0;
            }
        }
    }
`

export const TableFooter = styled.div.attrs({
    className: 'footer',
})`
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
    border-top: 1px solid ${colors.ui.backgroundMedium};
    background-color: white;
    padding: 6px;
`
